export const FILTERS_ORDER_SETTINGS_KEY = "selfServiceTemplatesFiltersOrder";

/** Number of days a template is considered "new" after creation */
export const NEW_TEMPLATE_THRESHOLD_DAYS = 7;
